<div id="compare-planogram-container">
  <div *ngIf="compare_planogram_ids.length>0">
    <mat-grid-list
      [cols]="compare_planogram_ids.length + (compare_planogram_ids.length==4||compare_planogram_ids.length==3?1:2)"
      rowHeight="280px"
      class="image-preview-list"
    >
      <mat-grid-tile class="left-align-grid-tile">
        <button mat-stroked-button (click)="goBack()" style="font-weight: 600;font-size: 0.95vw;">
          <em class="bi bi-arrow-left" style="margin-right: 5px"></em>
          Go Back
        </button>
      </mat-grid-tile>

      <mat-grid-tile *ngFor="let id of compare_planogram_ids">
        <div>
          <div
            style="margin:auto;"
            class="image-preview mat-badge mat-badge-overlap mat-badge-above mat-badge-after mat-badge-medium"
          >
           <img
              style="height: 150px; max-width: 100%;"
              [src]="compare_planogram_data[id].imageUrl"
              alt=""
            /> 
            <em
              class="bi bi-x-circle mat-badge-content mat-badge-active"
              style="color: red; cursor: pointer"
              (click)="removePlanogram(id)"
            ></em>
          </div>
          <!-- <p
            class="name mat-badge mat-badge-above mat-badge-before mat-badge-medium"
          >
            {{ compare_planogram_data[id]?.name }}
            <em
              class="bi bi-eye mat-badge-content mat-badge-active"
              style="color: red; cursor: pointer"
              (click)="openImagePreviewDialog()"
            ></em>
          </p> -->
          <p style="text-align: center;font-size: 1vw;">
            {{ compare_planogram_data[id]["cooler_details"].doors }} Door
           <!-- {{compare_planogram_data[id]['cooler_details'].cooler_capacity}}  -->
          </p>
        </div>
      </mat-grid-tile>

      <!-- <mat-grid-tile  *ngIf="compare_planogram_ids.length<3" class="right-align-grid-tile">
        <mat-card
          class="add-another-planogram-card"
          (click)="addPlanogramToCompare()"
          [ngClass]="{ disable: compare_planogram_ids.length === 3 }"
        >
          <em class="bi bi-plus"></em>
          <p>Add another planogram</p>
        </mat-card>
      </mat-grid-tile> -->
    </mat-grid-list>

    <div
      id="planogram-compare-data-accordion-container"
      *ngIf="compare_planogram_ids.length > 0"
    >
      <div style="height: 100%; width: 100%; overflow: auto">
        <mat-accordion id="planogram-data-accordion" multi>
          <mat-expansion-panel [expanded]="true">
            <mat-expansion-panel-header>
              <mat-panel-title> Overview </mat-panel-title>
            </mat-expansion-panel-header>
            <div *ngIf="compare_planogram_data">
              <mat-grid-list
                [cols]="compare_planogram_ids.length + (compare_planogram_ids.length==4||compare_planogram_ids.length==3?1:2)"
                class="planogrm-sales-grid"
                rowHeight="50px"
              >
                <mat-grid-tile
                  colspan="1"
                  class="border-bootom-content left-align-grid-tile"
                >
                  Unit
                </mat-grid-tile>
                <mat-grid-tile
                  class="border-bootom-content"
                  *ngFor="let id of compare_planogram_ids; let p_index = index"
                  colspan="1"
                >
                  {{ compare_planogram_data[id]?.overview?.unit}}
                </mat-grid-tile>
                <mat-grid-tile
                   *ngIf="compare_planogram_ids.length<3"
                  class="border-bootom-content"
                  colspan="1"
                ></mat-grid-tile>
                <mat-grid-tile
                colspan="1"
                class="border-bootom-content left-align-grid-tile"
              >
                Channel
              </mat-grid-tile>
              <mat-grid-tile
                class="border-bootom-content"
                *ngFor="let id of compare_planogram_ids; let p_index = index"
                colspan="1"
              >
                {{ compare_planogram_data[id]?.overview?.channel }}
              </mat-grid-tile>
                <mat-grid-tile
                *ngIf="compare_planogram_ids.length<3"
                  class="border-bootom-content"
                  colspan="1"
                ></mat-grid-tile>

                <!-- <mat-grid-tile colspan="1" class="left-align-grid-tile">
                  Status
                </mat-grid-tile>
                <mat-grid-tile
                  *ngFor="let id of compare_planogram_ids; let p_index = index"
                  colspan="1"
                >
                  <span
                    class="planogram-status"
                    [ngClass]="{
                      active:
                        compare_planogram_data[id]?.progress_status ===
                        CONFIG.PLANOGRAMSTATUS.ACTIVE,
                      inactive:
                        compare_planogram_data[id]?.progress_status ===
                        CONFIG.PLANOGRAMSTATUS.INACTIVE,
                      draft:
                        compare_planogram_data[id]?.progress_status ===
                        CONFIG.PLANOGRAMSTATUS.DRAFT
                    }"
                  >
                    {{ compare_planogram_data[id]?.progress_status }}
                  </span>
                </mat-grid-tile>
                <mat-grid-tile colspan="1"></mat-grid-tile> -->
              </mat-grid-list>
            </div>
          </mat-expansion-panel>

          <mat-expansion-panel [expanded]="true">
            <mat-expansion-panel-header>
              <mat-panel-title> Cooler Details </mat-panel-title>
            </mat-expansion-panel-header>
            <div *ngIf="compare_planogram_data">
              <mat-grid-list
                [cols]="compare_planogram_ids.length + (compare_planogram_ids.length==4||compare_planogram_ids.length==3?1:2)"
                class="planogrm-sales-grid"
                rowHeight="50px"
              >
                <mat-grid-tile
                  colspan="1"
                  class="border-bootom-content left-align-grid-tile"
                >
                  Cooler Type
                </mat-grid-tile>
                <mat-grid-tile
                  class="border-bootom-content"
                  *ngFor="let id of compare_planogram_ids; let p_index = index"
                  colspan="1"
                >
                  {{
                    compare_planogram_data[id]?.["cooler_details"]?.cooler_type
                  }}
                </mat-grid-tile>
                <mat-grid-tile
                *ngIf="compare_planogram_ids.length<3"
                  class="border-bootom-content"
                  colspan="1"
                ></mat-grid-tile>

                <mat-grid-tile
                  colspan="1"
                  class="border-bootom-content left-align-grid-tile"
                >
                  Banner
                </mat-grid-tile>
                <mat-grid-tile
                  class="border-bootom-content"
                  *ngFor="let id of compare_planogram_ids; let p_index = index"
                  colspan="1"
                >
                  {{ compare_planogram_data[id]["cooler_details"]?.banner }}
                </mat-grid-tile>
                <mat-grid-tile
                 *ngIf="compare_planogram_ids.length<3"
                  class="border-bootom-content"
                  colspan="1"
                ></mat-grid-tile>

                <mat-grid-tile
                  colspan="1"
                  class="border-bootom-content left-align-grid-tile"
                >
                  Doors
                </mat-grid-tile>
                <mat-grid-tile
                  class="border-bootom-content"
                  *ngFor="let id of compare_planogram_ids; let p_index = index"
                  colspan="1"
                >
                  {{ compare_planogram_data[id]["cooler_details"]?.doors }}
                </mat-grid-tile>
                <mat-grid-tile
                *ngIf="compare_planogram_ids.length<3"
                  class="border-bootom-content"
                  colspan="1"
                ></mat-grid-tile>

                <mat-grid-tile
                  colspan="1"
                  class="border-bootom-content left-align-grid-tile"
                >
                  Shelves
                </mat-grid-tile>
                <mat-grid-tile
                  class="border-bootom-content"
                  *ngFor="let id of compare_planogram_ids; let p_index = index"
                  colspan="1"
                >
                  {{ compare_planogram_data[id]["cooler_details"]?.shelves }}
                </mat-grid-tile>
                <mat-grid-tile
                *ngIf="compare_planogram_ids.length<3"
                  class="border-bootom-content"
                  colspan="1"
                ></mat-grid-tile>

                <mat-grid-tile
                  colspan="1"
                  class="border-bootom-content left-align-grid-tile"
                >
                  Facings
                </mat-grid-tile>
                <mat-grid-tile
                  class="border-bootom-content"
                  *ngFor="let id of compare_planogram_ids; let p_index = index"
                  colspan="1"
                >
                  {{ compare_planogram_data[id]["cooler_details"]?.facings }}
                </mat-grid-tile>
                <mat-grid-tile
                  *ngIf="compare_planogram_ids.length<3"
                  class="border-bootom-content"
                  colspan="1"
                ></mat-grid-tile>

                <mat-grid-tile colspan="1" class="left-align-grid-tile">
                  Door Handle Direction
                </mat-grid-tile>
                <mat-grid-tile
                  *ngFor="let id of compare_planogram_ids; let p_index = index"
                  colspan="1"
                >
                  {{
                    compare_planogram_data[id]["cooler_details"]
                      ?.door_handle_direction
                  }}
                </mat-grid-tile>
                <mat-grid-tile colspan="1"></mat-grid-tile>
              </mat-grid-list>
            </div>
          </mat-expansion-panel>

          <mat-expansion-panel [expanded]="true">
            <mat-expansion-panel-header>
              <mat-panel-title
                >One Turn Throughput
              </mat-panel-title>
            </mat-expansion-panel-header>
            <div *ngIf="compare_planogram_data">
              <mat-grid-list
                [cols]="compare_planogram_ids.length + (compare_planogram_ids.length==4||compare_planogram_ids.length==3?1:2)"
                class="planogrm-sales-grid"
                rowHeight="50px"
              >
                <mat-grid-tile
                  colspan="1"
                  class="border-bootom-content left-align-grid-tile"
                >
                  Revenue
                </mat-grid-tile>
                <mat-grid-tile
                  class="border-bootom-content"
                  *ngFor="let id of compare_planogram_ids; let p_index = index"
                  colspan="1"
                >
                ₹ {{
                    abbreviateNumber(
                      compare_planogram_data[id]["estimated_annualized_throughput"]?.revenue
                    )
                  }}
                </mat-grid-tile>
                <mat-grid-tile
                  *ngIf="compare_planogram_ids.length<3"
                  class="border-bootom-content"
                  colspan="1"
                ></mat-grid-tile>

                <mat-grid-tile
                  colspan="1"
                  class="border-bootom-content left-align-grid-tile"
                >
                  Profit
                </mat-grid-tile>
                <mat-grid-tile
                  class="border-bootom-content"
                  *ngFor="let id of compare_planogram_ids; let p_index = index"
                  colspan="1"
                >
                ₹ {{
                    abbreviateNumber(
                      compare_planogram_data[id]["estimated_annualized_throughput"]?.profit
                    )
                  }}
                </mat-grid-tile>
                <mat-grid-tile
                  *ngIf="compare_planogram_ids.length<3"
                  class="border-bootom-content"
                  colspan="1"
                ></mat-grid-tile>

                <mat-grid-tile
                  colspan="1"
                  class="border-bootom-content left-align-grid-tile"
                >
                  Volume
                </mat-grid-tile>
                <mat-grid-tile
                  class="border-bootom-content"
                  *ngFor="let id of compare_planogram_ids; let p_index = index"
                  colspan="1"
                >
                  {{
                    abbreviateNumber(
                      compare_planogram_data[id]["estimated_annualized_throughput"]?.volume
                    )
                  }}UC
                </mat-grid-tile>
                <mat-grid-tile
                  class="border-bootom-content"
                  colspan="1"
                ></mat-grid-tile>

                <!-- <mat-grid-tile colspan="1" class="left-align-grid-tile">
                  Transaction
                </mat-grid-tile>
                <mat-grid-tile
                  *ngFor="let id of compare_planogram_ids; let p_index = index"
                  colspan="1"
                >
                  {{
                    abbreviateNumber(
                      compare_planogram_data[id]["estimated_annualized_throughput"]?.transaction
                    )
                  }}
                  Units
                </mat-grid-tile>
                <mat-grid-tile colspan="1"></mat-grid-tile> -->
              </mat-grid-list>
            </div>
          </mat-expansion-panel>

          <mat-expansion-panel class="assortment-panel" [expanded]="true">
            <mat-expansion-panel-header>
              <mat-panel-title> Assortment </mat-panel-title>
            </mat-expansion-panel-header>
            <div *ngIf="compare_planogram_data">
              <!-- <mat-grid-list
                [cols]="compare_planogram_ids.length + 2"
                class="planogrm-assortment-grid quot-service-grid"
              >
                <mat-grid-tile
                 
                  colspan="1"
                  class="border-bootom-content left-align-grid-tile"
                  
                >
                   <div>
                    Category Distributio
                  </div> 
                </mat-grid-tile>
                <mat-grid-tile
                style="height: calc(50vh - 24px)"
                  class=" charts"
                  *ngFor="let id of compare_planogram_ids; let p_index = index"
                  colspan="1"
                >
                  <canvas
                    id="category-chart"
                    baseChart
                    [data]="
                      getBarChartData(
                        compare_planogram_data[id]['assortment']
                          .category_distribution,
                        true
                      )
                    "
                    [options]="chart_options"
                    [type]="'bar'"
                  >
                  </canvas>
                  <table>
                    <thead>
                      <tr>
                        <th></th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let label of getLabels('category_distribution',id);let i =index">
                        <td>
                          <div style="display:flex;gap:1vw">
                          <div [ngStyle]="{'width.vw':1,'height.vh':2,'background-color':category_colors[i]}"></div>
                         <div> {{label}}</div>
                        </div>
                        </td>
                        <td>{{compare_planogram_data[id].assortment.category_distribution[label]}}</td>
                      </tr>
                    </tbody>
                  </table>
                </mat-grid-tile>
                <mat-grid-tile
                  class="border-bootom-content"
                  colspan="1"
                ></mat-grid-tile>

                <mat-grid-tile colspan="1" class="left-align-grid-tile">
                   <div>
                    Brands Distribution
                  </div> 
                </mat-grid-tile>
                <mat-grid-tile
                style="height: calc(50vh - 24px)"
                  class="border-bootom-content charts"
                  *ngFor="let id of compare_planogram_ids; let p_index = index"
                  colspan="1"
                >
                  <canvas
                    id="brand-chart"
                    baseChart
                    [data]="
                      getBarChartData(
                        compare_planogram_data[id]['assortment']
                          .brand_distribution,
                        false
                      )
                    "
                    [options]="chart_options"
                    [type]="'bar'"
                  >
                  </canvas>
                  
                    <table>
                      <thead>
                        <tr>
                          <th></th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr *ngFor="let label of getLabels('brand_distribution',id);let i =index">
                          <td>
                            <div style="display:flex;gap:1vw">
                            <div [ngStyle]="{'width.vw':1,'height.vh':2,'background-color':category_colors[i]}"></div>
                           <div> {{label}}</div>
                          </div>
                          </td>
                          <td>{{compare_planogram_data[id].assortment.brand_distribution[label]}}</td>
                        </tr>
                      </tbody>
                    </table>
                 
                </mat-grid-tile>
                <mat-grid-tile colspan="1"></mat-grid-tile>
              </mat-grid-list> -->
               <div style="display:flex;border-bottom: 1px solid rgb(193, 190, 190);padding:4vh 0px">
                <div style="font-size:0.95vw;font-weight: 600;width:20vw;margin-left:3vh">Category Distribution (volume)</div>
                <div style="display: flex;flex-direction:column;padding:3vh 0vh 3vh 13vh;" *ngFor="let id of compare_planogram_ids; let p_index = index">
                  <div [ngStyle]="{'width.vw':(compare_planogram_ids.length==3?60:50)/compare_planogram_ids.length,'display':'flex','margin-bottom':'2vh'}">
                  <canvas
                  id="category-chart"
                  height="30vh"
                  baseChart
                  [data]="
                    getBarChartData(
                      compare_planogram_data[id]['assortment']
                        .category_distribution,
                      true
                    )
                  "
                  [options]="chart_options"
                  [type]="'bar'"
                >
                </canvas>
                </div>
                <table>
                  <thead>
                    <tr>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let label of getLabels('category_distribution',id);let i =index">
                      <td>
                        <div style="display:flex;gap:1vw">
                        <div [ngStyle]="{'width.vw':1,'height.vh':2,'background-color':category_colors[i]}"></div>
                       <div style="font-size: 0.9vw;font-weight: 500;"> {{label}}</div>
                      </div>
                      </td>
                      <td style="font-size: 0.9vw;font-weight: 600;padding-left: 2vw;">{{compare_planogram_data[id].assortment.category_distribution[label].toFixed(1)}}%</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div style="display:flex;padding:4vh 0px;border-bottom: 1px solid rgb(193, 190, 190);">
              <div style="font-size:0.95vw;font-weight: 600;width:20vw;margin-left:3vh;">Brand Distribution  (volume)</div>
              <div style="display:flex;flex-direction: column;padding:3vh 0vh 3vh 13vh;" *ngFor="let id of compare_planogram_ids; let p_index = index">
                <div [ngStyle]="{'width.vw':(compare_planogram_ids.length==3?60:50)/compare_planogram_ids.length,'display':'flex','margin-bottom':'2vh'}">
                  <canvas
                  height="30vh"
                  id="brand-chart"
                  baseChart
                  [data]="
                    getBarChartData(
                      compare_planogram_data[id]['assortment']
                        .brand_distribution,
                      false
                    )
                  "
                  [options]="chart_options"
                  [type]="'bar'"
                >
                </canvas>
              </div>
              <table>
                <thead>
                  <tr>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let label of getLabels('brand_distribution',id);let i =index">
                    <td>
                      <div style="display:flex;gap:1vw">
                      <div [ngStyle]="{'width.vw':1,'height.vh':2,'background-color':category_colors[i]}"></div>
                     <div style="font-size: 0.9vw;font-weight: 500"> {{label}}</div>
                    </div>
                    </td>
                    <td style="font-size: 0.9vw;font-weight: 600;padding-left: 2vw;">{{compare_planogram_data[id].assortment.brand_distribution[label].toFixed(1)}}%</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div style="display:flex;padding:4vh 0px">
            <div style="font-size:0.95vw;font-weight: 600;width:20vw;margin-left:3vh">Pack Segment Distribution (volume)</div>
            <div style="display: flex;flex-direction:column;padding:3vh 0vh 3vh 13vh;" *ngFor="let id of compare_planogram_ids; let p_index = index">
              <div [ngStyle]="{'width.vw':(compare_planogram_ids.length==3?60:50)/compare_planogram_ids.length,'display':'flex','margin-bottom':'2vh'}">
              <canvas
              id="category-chart"
              height="30vh"
              baseChart
              [data]="
                getBarChartData(
                  compare_planogram_data[id]['assortment'].pack_segment_distribution,
                  true
                )
              "
              [options]="chart_options"
              [type]="'bar'"
            >
            </canvas>
            </div>
            <table>
              <thead>
                <tr>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let label of getLabels('pack_segment_distribution',id);let i =index">
                  <td>
                    <div style="display:flex;gap:1vw">
                    <div [ngStyle]="{'width.vw':1,'height.vh':2,'background-color':category_colors[i]}"></div>
                   <div style="font-size: 0.9vw;font-weight: 500;"> {{label}}</div>
                  </div>
                  </td>
                  <td style="font-size: 0.9vw;font-weight: 600;padding-left: 2vw;">{{compare_planogram_data[id].assortment.pack_segment_distribution[label].toFixed(1)}}%</td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
            </div>
          </mat-expansion-panel>
        </mat-accordion>
      </div>
    </div>
  </div>
</div>

<app-loader [is_show_loader]="(is_show_loader | async)!"></app-loader>
